module.exports = __webpack_public_path__ + "img/avatar.94df8f34.png";